import { Infobulle } from './Infobulle';

/**
 * Les actions d'une liste en icônes (2026-10-08) : « Écrire à la
 * sélection » (Gmail) et « Exporter la liste » (Excel). Les images sont
 * celles fournies par Georges, aux couleurs des marques, seulement
 * réduites — servies en 50 px de haut, affichées en 20 px, nettes sur
 * les écrans haute densité (même procédé que `IconePdf`).
 *
 * Une icône seule ne se lit pas : le libellé vit dans `aria-label` et
 * dans l'infobulle commune, l'image est decorative (`alt=""`).
 */
function BoutonIcone({
  src,
  libelle,
  onClick,
  hauteur = 'h-5',
}: {
  src: string;
  libelle: string;
  onClick: () => void;
  /** Classe Tailwind de hauteur de l'image ; 20 px par defaut. */
  hauteur?: string;
}) {
  return (
    <Infobulle texte={libelle} className="inline-flex">
      <button
        type="button"
        aria-label={libelle}
        onClick={onClick}
        className="inline-flex h-8 w-8 items-center justify-center rounded-md border border-transparent hover:border-encre-200 hover:bg-white"
      >
        <img src={src} alt="" className={`${hauteur} w-auto`} draggable={false} />
      </button>
    </Infobulle>
  );
}

/** Le M de Gmail est plus large que haut : a 16 px il pese autant que la feuille Excel a 20 (2026-10-09). */
export function BoutonGmail({ libelle, onClick }: { libelle: string; onClick: () => void }) {
  return <BoutonIcone src="/assets/icone-gmail.png" libelle={libelle} onClick={onClick} hauteur="h-4" />;
}

export function BoutonExcel({ libelle, onClick }: { libelle: string; onClick: () => void }) {
  return <BoutonIcone src="/assets/icone-excel.png" libelle={libelle} onClick={onClick} />;
}
